export const SecondSubmitButtonStyles: any = {
    props: { variant: 'second-submit-button' },
    style: {
        backgroundColor: "#FFFFFF",
        color: '#173456',
        boxShadow: "0px 1px 3px 1px rgba(0, 0, 0, 0.27)",
        fontWeight: 700,
        fontSize:"1rem"
    }
}